import React, { useState} from 'react'
import { useSelector } from 'react-redux'
//Mui
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import {SelectStations} from './SelectStation';


export const ExpanderColumns = (props) => {
    const { items, type, categories, allClasses } = props
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    {type === "CREATE" ? 
                    <TableRow>
                        <TableCell align="left" >Descripción</TableCell>
                        <TableCell align="left">Número de Artículo</TableCell>
                        <TableCell align="left">Unidad de Medida</TableCell>
                        <TableCell align="left">Inventariable</TableCell>
                        <TableCell align="left">Clase</TableCell>
                        <TableCell align="left">Categoría</TableCell>
                        <TableCell align="left">Precio</TableCell>
                        <TableCell align="left">Precio Individual </TableCell>
                        <TableCell align="left">Estación</TableCell>
                        <TableCell align="right">Acciones</TableCell>
                    </TableRow> : 
                    <TableRow>
                        <TableCell align="left" >Descripción</TableCell>
                        <TableCell align="left" >Número de Artículo</TableCell>
                        <TableCell align="left">Precio Anterior</TableCell>
                        <TableCell align="left">Precio</TableCell>
                        <TableCell align="left">Precio Individual </TableCell>
                        <TableCell align="left">Estación</TableCell>
                        <TableCell align="right">Acciones</TableCell>
                    </TableRow>
                    }
                </TableHead>
                <TableBody>
                    {Object.values(items).map((row) => (
                        <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                            <SelectStations 
                            stations={row.stations} 
                            item={row} type={type} 
                            categories={categories} 
                            allClasses={allClasses}  
                            />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}